<template>
  <div class="profile">
    <h3><span>{{member_title}}</span> ｜ <i>{{member_eng_title}}</i></h3>
  </div>
</template>
<script>
export default {
  props: ["member_title", "member_eng_title"]
}
</script>
<style>
  .profile h3{
    color:#4b4d4b;
    font-size: 1.6rem;
    font-weight: bold;
    padding: 27px 0 5px 18px;
    margin-top: 0px;
    background-color: rgba(0, 0, 0, 0.07);
    border-bottom: 2px solid #4b4d4b;
  }
  /* @media (max-width: 768px){
    .profile h3{
      text-align: center;
    }
  } */
  @media (max-width: 576px){
    .profile h3{
      font-size: 1.3rem;
    }
  }
</style>